import { observer } from 'mobx-react-lite';
import TvWidgetContainer from './TvWidgetContainer';

const TvTechnicalAnalysis = observer(({ ticker }: { ticker: string }) => {
    return (
        <div
            // 모바일과 데스크탑에서 적당히 잘 보이는 크기로 설정
            className="mx-auto h-90 max-w-120"
        >
            <TvWidgetContainer
                scriptSrc="embed-widget-technical-analysis"
                configJson={{
                    displayMode: 'single',
                    interval: '1D',
                    disableInterval: false,
                    symbol: `${ticker}`,
                    showIntervalTabs: false,
                }}
            />
        </div>
    );
});

export default TvTechnicalAnalysis;
